import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const size = {
  extraSmall: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 6.75L6 8.25L7.5 6.75" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.00001 8.25L6.00001 5.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="1.5" y="3.5" width="9" height="6.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.5 2H8.5L10.5 3.5H1.5L3.5 2Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 9L8 11L10 9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M8.00001 11L8.00001 7"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2"
        y="4.66666"
        width="12"
        height="8.66667"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66667 2.66666H11.3333L14 4.66666H2L4.66667 2.66666Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  default: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 13.5L12 16.5L15 13.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 16.5L12 10.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <rect
        x="3"
        y="7"
        width="18"
        height="13"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 4H17L21 7H3L7 4Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 18L16 22L20 18"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16 22L16 14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <rect
        x="4"
        y="9.33334"
        width="24"
        height="17.3333"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33333 5.33334H22.6667L28 9.33334H4L9.33333 5.33334Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

function ArchiveIcon(props: SvgIconProps) {
  const item = size[(props.fontSize as "extraSmall" | "small" | "large") || "default"];

  return <SvgIcon {...props}>{item}</SvgIcon>;
}
export default ArchiveIcon;
